













































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {weekPlanningType} from '@/data/models/building';
import DateUtils from '@/helpers/date-utils';
import DragSelect from '@/components/ui/DragSelect.vue';

@Component({
  components: {
    'drag-select-container': DragSelect,
  },
})
export default class Planning extends Vue {
  @Prop({required: true})
  planning: weekPlanningType;

  @Prop({required: true})
  title: string;

  @Prop({required: true})
  isCreated: boolean;

  samePlanning: boolean = false;

  @Watch("isCreated", {immediate: true})
  onIsCreatedChange(): void {
    this.samePlanning = this.isCreated;
  }

  get planningFiltered(): weekPlanningType[number][] {
    return this.samePlanning ? [this.planning[0]] : this.planning;
  }

  dayLocalized(value: number): string {
    return DateUtils.intToDay(value);
  }

  hourHH(value: number): string {
    return ('0' + value).slice(-2)
  }

  getSelectedItems(selectedItems: any[]): void {
    selectedItems.forEach(
        (item) => {
          item['$attrs']['item'].state = selectedItems.length == 1 ? !item['$attrs']['item'].state : true;
        },
    );

    this.setSameHours();
  }

  clearItems(day: weekPlanningType[number]): void {
    (day['hours'] as Record<string, any>[]).forEach((hour) => hour['state'] = false);

    this.setSameHours();
  }

  setSameHours(): void {
    if (this.samePlanning) {
      this.planning.forEach((day, index) => {
        if (index != 0) {
          day['hours'] = JSON.parse(JSON.stringify(this.planning[0]['hours']));
        }
      });
    }
  }
}
